module.exports = __webpack_public_path__ + "img/scirocco-177-001.a028ff62.jpg";